<template>
  <div class="detail">
    <div class="container">
      <el-button class="back-button" @click="goHome">返回</el-button>
      <div class="header">
        <img class="logo" :src="detailMap[type]?.logo" />
        <div class="info">
          <div class="title">
            {{ detailMap[type]?.title }}
            <span class="description">{{ detailMap[type]?.description }}</span>
          </div>
          <div class="phone-description">
            {{ detailMap[type]?.description }}
          </div>
          <div class="tip" v-if="detailMap[type]?.tip">
            {{ detailMap[type]?.tip }}
          </div>
        </div>
      </div>
      <div class="content" v-if="detailMap[type]?.detail">
        <p>
          {{ detailMap[type]?.detail }}
        </p>
      </div>
      <div class="product-list" v-if="detailMap[type]?.productList?.length > 0">
        <div
          class="product-item"
          v-for="item in detailMap[type]?.productList"
          :key="item.title"
        >
          <span class="title" @click="goUrl(item.url)">{{ item.title }}</span>
          ：{{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  onMounted,
  inject,
  nextTick,
} from "vue";
import { checkUserOperateAuth } from "@/utils/utils.js";
import { useRouter, useRoute } from "vue-router";

const route = useRoute();
const router = useRouter();

const emits = defineEmits(["set-scroll"]);

const openDialogLogin = inject("openDialogLogin");

const type = ref(route.params.type);

const detailMap = {};

const goHome = () => {
  router.push({
    name: "Home",
    query: {
      type: route.query.type,
    },
  });
};

const goUrl = async (url) => {
  await checkUserOperateAuth(openDialogLogin);
  window.open(url, "_blank");
};

onMounted(() => {
  emits("set-scroll", 0);
});
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .container {
    margin-top: 5%;
    width: 45%;
    border-radius: 14px;
    background-color: #fff;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;
    position: relative;
    margin-bottom: 60px;
    .back-button {
      position: absolute;
      right: 30px;
      top: 20px;
    }
    .header {
      display: flex;
      gap: 30px;
      align-items: center;
      img {
        height: 90px;
      }
      .info {
        display: flex;
        flex-direction: column;
        gap: 15px;
        .title {
          color: #383838;
          font-size: 20px;
          font-weight: 550;
          .description {
            color: #848486;
            font-size: 15px;
            font-weight: 500;
            margin-left: 15px;
          }
        }
        .phone-description {
          color: #848486;
          font-size: 15px;
          font-weight: 500;
          display: none;
        }
        .tip {
          color: #cf1301;
          font-size: 15px;
        }
        .button {
          width: 80px;
          background-color: rgba(12, 49, 115, 0.12);
          color: $theme-color;
          border: none;
          margin-right: 10px;
        }
      }
    }
    .content {
      text-align: justify;
      line-height: 30px;
      font-size: 15px;
      p {
        margin: 10px;
        text-indent: 4ch;
      }
    }
    .product-list {
      .product-item {
        text-align: justify;
        line-height: 36px;
        font-size: 15px;
        .title {
          font-size: 16px;
          font-weight: 550;
          cursor: pointer;
        }
        .title:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .container::after {
    content: "";
    width: 100%;
    height: 100%;
    z-index: -1;
    position: absolute;
    left: 20px;
    top: 20px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .detail {
    .container {
      margin-top: 10%;
      width: calc(100% - 40px);
      padding: 70px 30px 50px 30px;
      gap: 20px;
      margin-bottom: 40px;
      .header {
        gap: 20px;
        .info {
          gap: 10px;
          .title {
            .description {
              display: none;
            }
          }
          .phone-description {
            display: block;
          }
        }
      }
    }
  }
}
</style>
